export interface Testimonial {
  quote: string
  name: string
  role: string
}

export const testimonials: Testimonial[] = [
  {
    quote: '„Dokładnie tego potrzebowałem. Cały sezon treningowy mam zaplanowany.”',
    name: 'Marcin K.',
    role: 'Trener klubowy, Poznań',
  },
  {
    quote: '„Nie jestem specjalistą od siatkówki, a lekcje WF wreszcie mają sens.”',
    name: 'Anna W.',
    role: 'Nauczycielka WF',
  },
  {
    quote: '„Diagramy boiska są tak jasne, że ćwiczenia tłumaczę w 30 sekund.”',
    name: 'Tomasz L.',
    role: 'Trener młodzieży U14',
  },
  {
    quote: '„Same testy sprawności oszczędziły mi tygodnie pracy.”',
    name: 'Katarzyna B.',
    role: 'Trenerka, szkoła sportowa',
  },
  {
    quote: '„Progresja poziom po poziomie widocznie podniosła grę mojego zespołu.”',
    name: 'Piotr Z.',
    role: 'Trener II ligi',
  },
  {
    quote: '„Rodzice od razu widzą, że treningi mają plan i profesjonalną strukturę.”',
    name: 'Ewa M.',
    role: 'Koordynatorka sekcji siatkówki',
  },
]
